module.exports = __webpack_public_path__ + "img/14.704a4c8c.svg";